import { css } from 'lit';
export const VideoDisplayCss = css `
    .video-container {
        position: relative;
        width: 100%;
        aspect-ratio: 16 / 9;
        margin: 0 auto;
        border-radius: 12px;
        background-color: #222;
        border: 2px dashed #555;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        overflow: hidden;
        /* Added flex properties to center the content wrapper */
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .video-container.dragging-over {
        border-color: #1877f2;
        background-color: #333;
    }
    .video-container .content-wrapper {
        /* No longer needs absolute positioning */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #eee;
    }
    .video-container .icon {
        width: 25%; 
        height: 25%;
        max-width: 96px; /* Caps the icon size on very large screens */
        margin-bottom: 16px;
        color: rgba(255, 255, 255, 0.7);
        transition: color 0.2s ease;
    }
    .video-container:hover .icon {
        color: rgba(255, 255, 255, 1);
    }
    .video-container .prompt { color: #fff; }
    .video-container .support-text { color: #aaa; }
    .video-preview {
        width: 100%; height: 100%;
        object-fit: cover;
    }

    .video-preview-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        line-height: 0; /* Removes extra space below the video element */
    }

    .video-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
        pointer-events: none;
        border-radius: 8px; /* Match video container's radius if any */
    }

    .video-preview-wrapper:hover .video-overlay {
        opacity: 1;
    }

    .video-overlay .overlay-button {
        background-color: rgba(255, 255, 255, 0.9);
        color: #374151;
        border: 1px solid #d1d5db;
        padding: 8px 16px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 0.9rem;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 8px;
        pointer-events: auto;
    }

    .video-overlay .overlay-button:hover {
        background-color: #fff;
    }


    .video-overlay .overlay-button .icon {
        width: 20px;
        height: 20px;
        margin: 0;
        color: #3b82f6; 
    }
`;
